var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"translate-buttons",class:{
        'btn-animate-fadeout': _vm.btnAnimate == true,
        'kamikita-translate-btns': _vm.siteHandle == 'kamikita',
    }},_vm._l((_vm.getOptions()),function(code){return _c('button',{key:code,staticClass:"btn btn-outline",class:{ 'active': _vm.getLang() === code },attrs:{"disabled":_vm.btnAnimate},on:{"click":function($event){return _vm.setLang(code)}}},[_vm._v(" "+_vm._s(_vm.getName(code))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }